<template>
  <AppSection class="dark-section how-it-works-section !px-0">
    <h2 class="heading-3 mx-5">
      {{
        $t(
          `section.benefits.how_it_works.heading.${$userStore.isLoggedIn ? 'logged_in' : 'logged_out'}`
        )
      }}
    </h2>

    <ol
      class="steps mx-5 flex flex-col justify-center gap-4 text-center lg:flex-row"
    >
      <li>
        <div class="text-xl font-bold">
          {{
            $t(
              `section.benefits.how_it_works.card.step_2.${$userStore.isLoggedIn ? 'logged_in' : 'logged_out'}.heading`
            )
          }}
        </div>
        <p class="">
          {{
            $t(
              `section.benefits.how_it_works.card.step_2.${$userStore.isLoggedIn ? 'logged_in' : 'logged_out'}.excerpt`
            )
          }}
        </p>
      </li>

      <li>
        <div class="text-xl font-bold">
          {{
            $t(
              `section.benefits.how_it_works.card.step_3.${$userStore.isLoggedIn ? 'logged_in' : 'logged_out'}.heading`
            )
          }}
        </div>
        <p class="">
          {{
            $t(
              `section.benefits.how_it_works.card.step_3.${$userStore.isLoggedIn ? 'logged_in' : 'logged_out'}.excerpt`
            )
          }}
        </p>
      </li>

      <li>
        <div class="text-xl font-bold">
          {{
            $t(
              `section.benefits.how_it_works.card.step_4.${$userStore.isLoggedIn ? 'logged_in' : 'logged_out'}.heading`
            )
          }}
        </div>
        <p class="">
          {{
            $t(
              `section.benefits.how_it_works.card.step_4.${$userStore.isLoggedIn ? 'logged_in' : 'logged_out'}.excerpt`
            )
          }}
        </p>
      </li>

      <li>
        <div class="text-xl font-bold">
          {{
            $t(
              `section.benefits.how_it_works.card.step_5.${$userStore.isLoggedIn ? 'logged_in' : 'logged_out'}.heading`
            )
          }}
        </div>
        <p class="">
          {{
            $t(
              `section.benefits.how_it_works.card.step_5.${$userStore.isLoggedIn ? 'logged_in' : 'logged_out'}.excerpt`
            )
          }}
        </p>
      </li>
    </ol>

    <div class="mx-5 mt-3 flex justify-center md:mt-7">
      <AppUpgradeModal
        v-if="$userStore.showUpgradePlan"
        :user-plan="$userStore.highestPlan"
        :upgrade-plan="
          $plansStore.getPlanByTier('vip', $userStore.highestPlan?.period)
        "
      />
      <AppMembershipButton v-if="$userStore.isLoggedOut" />
    </div>
  </AppSection>
</template>

<style lang="scss" scoped>
.how-it-works-section {
  @apply bg-[url('@/assets/images/how-it-works-background-sm.svg')] bg-[length:100%_100%] bg-left-top bg-no-repeat md:bg-[url('@/assets/images/how-it-works-background.svg')] md:bg-[length:auto_100%];
}

.steps {
  li {
    @apply flex flex-1 flex-col gap-3 rounded-lg bg-pure-white p-5 text-black;

    p {
      @apply flex flex-grow justify-center;
    }
  }
}
</style>
